/* DIVETIA (Shane2507, 2026-11-03): Bundler's "You got $X OFF / Apply discount and go to checkout?" popup is
   removed. Bundler renders it as #bndlr-discount-message.bndlr-go-to-checkout; hide it and drop it if appended. */
(function () {
  try {
    if (window.DV_BNDLR_POPUP_SUPPRESSED) return;
    window.DV_BNDLR_POPUP_SUPPRESSED = true;
    var style = document.createElement('style');
    style.setAttribute('data-dv', 'bndlr-popup-off');
    style.textContent = '#bndlr-discount-message,.bndlr-go-to-checkout{display:none!important;visibility:hidden!important;pointer-events:none!important}';
    (document.head || document.documentElement).appendChild(style);
    var drop = function () {
      var el = document.getElementById('bndlr-discount-message');
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    drop();
    if (window.MutationObserver) {
      new MutationObserver(drop).observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch (error) { /* non-browser environments */ }
})();
(function () {
  'use strict';

  if (!/^\/a\/bundles\//.test(window.location.pathname)) return;

  var PRODUCT_CARD_SELECTOR = '.bndlr-product';
  var TITLE_SELECTOR = '.bndlr-product-title';
  var OPTION_SELECT_SELECTOR = 'select.bndlr-select-option';
  var HIDDEN_VARIANT_SELECTOR = 'select[name="variant_id"]';
  var STONE_TITLE_RE = /\s+[—-]\s+Lab-Grown\s+(Sapphire|Pink Diamond|White Diamond)\s*$/i;
  var SIDEBAR_TITLE_RE = /([^—\n]+?)\s+[—-]\s+Lab-Grown\s+(Sapphire|Pink Diamond|White Diamond)\s+-\s+(Sapphire|Pink Diamond|White Diamond)/gi;

  var scheduled = false;

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function selectedStone(card) {
    var optionSelect = card.querySelector(OPTION_SELECT_SELECTOR);
    if (optionSelect && clean(optionSelect.value)) return clean(optionSelect.value);

    var variantSelect = card.querySelector(HIDDEN_VARIANT_SELECTOR);
    var selectedOption = variantSelect && variantSelect.options && variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      return clean(selectedOption.getAttribute('data-option0') || selectedOption.textContent || selectedOption.value);
    }

    return '';
  }

  function baseTitle(title) {
    return clean(title).replace(STONE_TITLE_RE, '').trim();
  }

  function setTitleAttribute(node, title) {
    if (!node || !title) return;
    node.setAttribute('title', title);
    if (node.tagName === 'IMG') {
      node.setAttribute('alt', title);
    }
  }

  function updateProductCards(root) {
    root.querySelectorAll(PRODUCT_CARD_SELECTOR).forEach(function (card) {
      var title = card.querySelector(TITLE_SELECTOR);
      if (!title) return;

      var stone = selectedStone(card);
      if (!stone || !/sapphire|diamond/i.test(stone)) return;

      var originalTitle = title.getAttribute('data-divetia-base-title') || title.textContent;
      var base = baseTitle(originalTitle);
      if (!base) return;

      title.setAttribute('data-divetia-base-title', originalTitle);

      var updatedTitle = base + ' — Lab-Grown ' + stone;
      if (clean(title.textContent) !== updatedTitle) title.textContent = updatedTitle;
      setTitleAttribute(title, updatedTitle);

      card.querySelectorAll('.bndlr-product-image, .bndlr-product-image-url').forEach(function (node) {
        setTitleAttribute(node, updatedTitle);
        if (node.getAttribute('aria-label')) node.setAttribute('aria-label', updatedTitle);
      });
    });
  }

  function normalizeSidebarText(value) {
    return String(value || '').replace(SIDEBAR_TITLE_RE, function (_, prefix, _oldStone, selectedStoneName) {
      return clean(prefix) + ' — Lab-Grown ' + selectedStoneName;
    });
  }

  function normalizeTextNode(node) {
    var next = normalizeSidebarText(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function updateSidebarSummary(root) {
    root.querySelectorAll('.bndlr-sectioned-status-box-product, [class*="status-box-product"]').forEach(function (item) {
      var walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      var textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach(normalizeTextNode);

      item.querySelectorAll('[title], [aria-label], img[alt]').forEach(function (node) {
        ['title', 'aria-label', 'alt'].forEach(function (attr) {
          if (!node.hasAttribute(attr)) return;
          var current = node.getAttribute(attr);
          var next = normalizeSidebarText(current);
          if (next !== current) node.setAttribute(attr, next);
        });
      });
    });
  }

  function run() {
    scheduled = false;
    updateProductCards(document);
    updateSidebarSummary(document);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest || !event.target.closest(PRODUCT_CARD_SELECTOR)) return;
    if (!event.target.matches('select')) return;
    schedule();
    window.setTimeout(run, 120);
    window.setTimeout(run, 400);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest || !event.target.closest('.bndlr-add-to-sectioned-bundle, .bndlr-remove-bundle-item, .bndlr-sectioned-status-box-product')) return;
    window.setTimeout(run, 120);
    window.setTimeout(run, 400);
  }, true);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
